module.exports = __webpack_public_path__ + "fonts/Lato-Light.a7cc44c.woff2";